export const debounce = (fn: any, wait: number) => {
  var timeout: NodeJS.Timeout | null = null; //定义一个定时器
  return (...args: any[]): any => {
    if (timeout !== null) clearTimeout(timeout); //清除这个定时器
    timeout = setTimeout(() => {
      fn(...args);
    }, wait);
  };
};
